import React, { useState } from 'react';
import Modal from '../ProfileV2/shared/Modal';
import { logCrmEvent } from '@javascripts/util/eventLogging';
import Icons from '@components/shared/icons';
import Fetch from '@components/util/Fetch';
import TeamsInviteIcon from '@images/svg/teams-invite.svg?react';

import './styles.scss';

const TeamInvitationPendingModal = ({ data }) => {
  const {
    inviterName,
  } = data;

  const [isOpen, setIsOpen] = useState(true);

  const dismiss = async () => {
    logCrmEvent('disruptor_dismissed', { type: 'team_invitation_pending' });
    const resp = await Fetch.post({ url: '/teams/accept_decline_invite', payload: { accepted: 0 } });
    if (window.updateNotice) {
      if (resp.error) {
        window.updateNotice({ header: 'Error!', message: resp.error }, 3000);
      } else {
        window.updateNotice({ header: "Success!", message: 'Invitation declined.' }, 3000);
      }
    }
    setIsOpen(false);
  };

  const accept = async () => {
    logCrmEvent('disruptor_submitted', { type: 'team_invitation_pending' });
    const resp = await Fetch.post({ url: '/teams/accept_decline_invite', payload: { accepted: 1 } });
    if (window.updateNotice) {
      if (resp.error) {
        window.updateNotice({ header: 'Error!', message: resp.error }, 3000);
      } else {
        window.updateNotice({
          header: "Success!",
          message: "You've joined the Team. You can manage this in your account settings."
        }, 3000);
      }
    }
    setIsOpen(false);
  };

  return (
    <Modal
      close={dismiss}
      id="team-invitation-pending-modal"
      status={isOpen ? 'active' : 'hidden'}
    >
      <div className="team-invitation-pending-modal edit-modal-inner">
        <button
          type="button"
          className="close-button"
          onClick={dismiss}
        >
          <Icons type="close" />
        </button>
        <TeamsInviteIcon className="teams-invite-icon margin-bottom-16" />
        <h2 className="headline-2 margin-bottom-10">Team Invitation</h2>
        <p className="large-slim-font margin-bottom-28">
          You've received an invitation from {inviterName} to become a member of their team on ReferralExchange.
        </p>
        <div className="button-container">
          <button
            type="button"
            className="profile-edit-button black-white"
            onClick={dismiss}
          >
            <Icons type="close" />
            Decline
          </button>
          <button
            type="button"
            className="profile-edit-button submit"
            onClick={accept}
          >
            <Icons type="check-circle-alt" />
            Accept Invitation
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default TeamInvitationPendingModal;
